module.exports = __webpack_public_path__ + "media/luxury-2026/kingdom-chef-kitchen-927b72af.jpg";